import React, { useContext, useEffect } from 'react';
import { FaTrash, FaEye } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import Table from '../../components/common/table/Table'; // Adjust the import path as necessary
import UserContext from '../../context/userContext/UserContext';
import ActionButtons from '../../components/common/ActionButtons';
import { useModal } from '@/components/common/modal/ModalContext';
import UserRegistrationModal from './UserRegistrationModal';

// Define the getStatusClass function
const getStatusClass = (active) => {
  return active ? 'text-black bg-green-200' : 'text-black bg-red-200';
};

const UsersTable = () => {
  const {
    userData,
    filteredUsers,
    getAllUsers,
    sortBy,
    setSortBy,
    sortDir,
    setSortDir,
  } = useContext(UserContext);
  const { openModal, closeModal, isModalOpen } = useModal();

  const handleOpenModal = (user) => {
    openModal(
      <UserRegistrationModal closeModal={closeModal} data={user} />,
      'Update User',
    );
  };

  // Your columns configuration
  const columns = [
    {
      header: 'USER',
      render: (user) => (
        <div className="py-2 px-4 flex items-center">
          <img
            src="images/user.png"
            alt="user"
            className="w-10 h-10 rounded-full mr-2"
          />
          <div className="ml-2 py-2 px-4">
            <p>{`${user.firstName} ${user.lastName}`}</p>
          </div>
        </div>
      ),
      field: 'firstName',
    },
    { header: 'EMAIL', field: 'email' },
    { header: 'ROLE', field: 'role' },
    {
      header: 'STATUS',
      render: (user) => (
        <span
          className={`px-2 py-1 w-20 text-center inline-block rounded-full ${getStatusClass(
            user.active,
          )}`}
        >
          {user.active ? 'active' : 'inactive'}
        </span>
      ),
    },
    {
      header: 'ACTIONS',
      render: (user) => (
        <ActionButtons
          actions={[
            {
              icon: <MdEdit />,
              onClick: () => handleOpenModal(user),
              tooltip: 'Edit User',
              className: 'text-gray-500',
            },
          ]}
        />
      ),
    },
  ];

  const handleSortChange = ({ field, direction }) => {
    setSortBy(field); // Update the sortBy field
    setSortDir(direction); // Update the sort direction
    getAllUsers(field, direction); // Fetch sorted data
  };

  return (
    <>
      {filteredUsers?.length > 0 ? (
        <Table
          columns={columns}
          data={filteredUsers}
          onSortChange={handleSortChange} // Pass sorting handler
          sortConfig={{ field: sortBy, direction: sortDir }} // Pass current sorting state
          // onIconClick=}
        />
      ) : (
        <>
          <div className="font-800 text-center m-20 text-3xl">
            No data found
          </div>
        </>
      )}
    </>
  );
};

export default UsersTable;
